import React from "react";
import { useToasts } from "../../hooks/useNotification";

const ICONS = {
  success: "✓",
  error: "✕",
  info: "ℹ",
  warning: "⚠",
};

const TITLES = {
  success: "Success",
  error: "Error",
  info: "Info",
  warning: "Warning",
};

function Toast() {
  const { toasts, api } = useToasts();
  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.type}`}>
          <div className="toast-icon">{ICONS[t.type] || "•"}</div>
          <div className="toast-body">
            <div className="toast-title">{t.title || TITLES[t.type]}</div>
            <div>{t.message}</div>
          </div>
          <button
            type="button"
            className="toast-close"
            onClick={() => api.dismiss(t.id)}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

export default Toast;
